import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

interface CommonBannerProps {
    title: string;
    pc: string;
    pad: string;
    h5: string;
}

const CommonBanner: React.FC<CommonBannerProps> = ({ title, pc, pad, h5 }) => {
    // 使用useState来管理随机类名，确保服务端和客户端一致性
    const [randomClass, setRandomClass] = useState<string>('');

    useEffect(() => {
        // 只在客户端生成随机类名
        setRandomClass('common-banner-' + Math.random().toString(36).substring(2, 15));

        // setTimeout(() => {
        //     const productBoxScene = AniContainer.create({
        //         triggerElement: `.${styles.CommonBanner}`,
        //         triggerHook: 1,
        //         offset: 0,
        //         duration: 1000, // 动画持续时间
        //         asyncFromTo: [
        //             // product-list-box根据设备类型设置不同的动画效果
        //             [`.${styles.CommonBanner}`, { scale: 0.6 }, { scale: 1 }, 1],
        //         ],
        //         asyncTimeLine: [0], // 立即开始动画
        //     });

        //     AniContainer.scrollHandle(); // 执行一次初始化
        // });
    }, []);

    return (
        <div className={styles.CommonBanner + (randomClass ? ' ' + randomClass : '')}>
            <EcoImg pc={pc} pad={pad} h5={h5} />
            <div className="title-box">
                <div className="eco-title title">{title}</div>
            </div>
        </div>
    );
};

export default CommonBanner;
